import { GET_PROFILE } from "../../resources/actionTypes";

const initialState = {
  profileDetails: [],
  loading: false,
  error: null,
};

export const userProfile = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROFILE.GET_PROFILE_REQUESTED:
      return {
        ...state,
        loading: true,
        isAuth: false,
      };
    case GET_PROFILE.GET_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        isAuth: true,
        profileDetails: action.userProfile,
      };
    case GET_PROFILE.GET_PROFILE_FAILED:
      return {
        ...state,
        loading: false,
        isAuth: false,
        error: action.message,
      };
    default:
      return state;
  }
};
